import { Paper } from '@mui/material'
import styled from 'styled-components'

export const StyledPaper = styled(Paper)`
  padding: 32px;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`
